import { useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { hydrateEndUserProfile } from 'services/endUser/hydrateEndUserProfile';
import { buildEndUserAuthKey } from 'services/endUser/loadEndUserDashboardState';
import { resolveEndUserAuth } from 'services/endUser/resolveEndUserAuth';

import type { RootState } from 'store/store';

/**
 * Hydrates Redux with end-user profile fields from GET /eu/{euId}/state for all authenticated routes.
 */
export function useHydrateEndUserDashboardState(): void {
  const dispatch = useDispatch();
  const euId = useSelector((state: RootState) => state.auth.euId);
  const idToken = useSelector((state: RootState) => state.userSession.idToken);
  const lastHydratedAuthKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const auth = resolveEndUserAuth({ euId, idToken });
    if (!auth.euId || !auth.idToken) {
      return;
    }

    const authKey = buildEndUserAuthKey(auth.euId, auth.idToken);
    if (lastHydratedAuthKeyRef.current === authKey) {
      return;
    }

    lastHydratedAuthKeyRef.current = authKey;
    void hydrateEndUserProfile(auth.euId, auth.idToken, dispatch);
  }, [dispatch, euId, idToken]);
}
